import CONSTANTS from 'utils/constants';
import {fetch as fetchPolyfill} from 'whatwg-fetch';

const timeoutMilliseconds = 90000;

const post = (url, method, token, data = {}, fullUrl = false, isPdf) => {
  return timeoutPromise(timeoutMilliseconds, fetchPolyfill(fullUrl ? url : `${CONSTANTS.API_URL}/${url}`, {
    method: method,
    mode: 'cors',
    headers: {
      'Content-Type': isPdf ? 'application/pdf' : 'application/json',
      'Authorization': `Bearer ${token}`
    }, body: JSON.stringify(data)
  }).then(async (response) => {
    const contentType = response.headers.get("Content-Type") || "";

    if (!response.ok) {
      const errorData = contentType.includes("application/json") ? await response.json() : await response.text();
      const error = new Error(`HTTP error ${response.status}`);
      error.data = errorData;
      throw error;
    }

    if (contentType.includes("application/pdf")) {
      return await response.blob();
    } else if (contentType.includes("application/json")) {
      return await response.json();
    } else {
      return await response.text();
    }
  }))
}

const get = (url, method, token, queryString) => {
  const urlWithParams = new URL(`${CONSTANTS.API_URL}/${url}`);
  urlWithParams.search = new URLSearchParams(queryString).toString();

  return timeoutPromise(timeoutMilliseconds, fetchPolyfill(urlWithParams, {
    method: method,
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    searchParams: queryString,
  }).then(data => data.json()))
}

const timeoutPromise = (ms, promise) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('TIMEOUT'))
    }, ms)

    promise
      .then(value => {
        clearTimeout(timer)
        resolve(value)
      })
      .catch(reason => {
        clearTimeout(timer)
        reject(reason)
      })
  })
}

export const call = (url, method, token, data = {}, fullUrl = false) => {
  if(method === 'POST' || method === 'PATCH') {
    return post(url, method, token, data, fullUrl)
  } else {
    return get(url, method, token, data, fullUrl)
  }
}
